module.exports = __webpack_public_path__ + "img/burner-mining-drill-W-shadow.df91acbe.png";